import React from 'react';

import { Box, Card, colors, Container, makeStyles, Typography } from '@material-ui/core';
import { RouteComponentProps } from 'react-router-dom';

import Localized from 'components/Localized';
import Page from 'components/Page';
import { toShortLocale, useLocalization } from 'services/localization/localization';
import { userSelector } from 'store/session/sessionSelectors';
import { useTypedSelector } from 'store/store';
import { darkBackground } from 'theme/theme';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: darkBackground,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  card: {
    padding: theme.spacing(6),
    borderWidth: 8,
    borderColor: colors.common.white,
    hoverBorderColor: colors.common.white,
  },
}));

const Dashboard: React.FC<RouteComponentProps> = (_) => {
  const classes = useStyles();
  const { getLocalizedString, selectedLanguage } = useLocalization();

  const user = useTypedSelector(userSelector);

  const releaseNotesLink =
    selectedLanguage === 'nl-NL'
      ? 'https://www.reducept.com/nl/blog/product-update-release-notes-van-4-april-2022'
      : 'https://www.reducept.com/blog/product-update-release-notes-april-4-2022';

  return (
    <Page className={classes.root} title='Dashboard - Reducept'>
      <Box display='flex' flexDirection='column' height='100%'>
        <Container maxWidth='sm'>
          <Card className={classes.card}>
            <Typography color='textPrimary' variant='h2'>
              {getLocalizedString('dashboard_welcome', { username: user.name ?? 'Reducept user' })}
            </Typography>
            <br />
            <Localized
              id='release_notes'
              elems={{
                bold_text: <b></b>,
                linebreak: <br />,
                blog_link: <a target='_blank' href={releaseNotesLink} rel='noreferrer'></a>,
                support_link: (
                  <a
                    target='_blank'
                    href={`mailto:${getLocalizedString('support_link')}`}
                    rel='noreferrer'
                  ></a>
                ),
              }}
            >
              <Typography color='textPrimary' variant='body1'>
                {getLocalizedString('release_notes_part_1')}
                <br />
                <br />
                {getLocalizedString('release_notes_part_2')}
                <br />
                <br />
                {getLocalizedString('release_notes_part_3')}
              </Typography>
            </Localized>
          </Card>
        </Container>
      </Box>
    </Page>
  );
};

export default Dashboard;
